module.exports = "<route-page></route-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/route.html
// module id = 1407
// module chunks = 0